import { Box, Container, Grid, Title } from '@mantine/core';
import { FC, PropsWithChildren } from 'react';
import { FooterLinks } from 'src/components/FooterLinks';
import { Icon } from 'src/components/Icon';

import styles from './styles.module.css';

type Props = {
  title?: string;
  subtitle?: string;
};

export const AuthFullLayout: FC<PropsWithChildren<Props>> = ({
  children,
  title,
  subtitle,
}) => (
  <Container fluid className={styles.layout}>
    <Box className={styles.branding}>
      <Icon name="authFullBackground" className={styles.brandingBackground} />
    </Box>
    <Box className={styles.content}>
      <Box>
        <Box className={styles.heading}>
          {title && (
            <>
              <Title ta="center" className={styles.title} order={1}>
                {title}
              </Title>
            </>
          )}

          {subtitle && (
            <Title ta="center" className={styles.subtitle} order={2}>
              {subtitle}
            </Title>
          )}
        </Box>

        {children}
      </Box>

      <Grid>
        <Grid.Col span={6} offset={3}>
          <FooterLinks />
        </Grid.Col>
      </Grid>
    </Box>
  </Container>
);
